"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrCadHierarchicalPortNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const orcadHighestLevelWins_1 = require("./orcadHighestLevelWins");
class OrCadHierarchicalPortNamingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        if (!group.hasLabelType('hierarchical-port')) {
            return undefined;
        }
        if (!group.hasLabelType('alias') && this.instancesWithPinConnections(group) > 1) {
            return undefined;
        }
        const candidates = [];
        for (const [instance, nets] of group.getNets()) {
            const depth = instance.path.length;
            for (const net of nets) {
                const netName = net.name.valueOf();
                if (netName && !netName.startsWith('Net_auto_')) {
                    candidates.push({ name: netName, depth });
                }
                for (const label of net.labels) {
                    if (label.labelType === 'alias' || label.labelType === 'hierarchical-port') {
                        candidates.push({
                            name: label.formattedLabel ?? label.originalLabel,
                            depth,
                        });
                    }
                }
            }
        }
        if (candidates.length === 0) {
            return undefined;
        }
        candidates.sort((a, b) => {
            if (a.depth !== b.depth) {
                return a.depth - b.depth;
            }
            return sigma_engine_shared_1.Utils.naturalStringSort(a.name, b.name);
        });
        if ((0, orcadHighestLevelWins_1.deferToShallowerSystemId)(group, candidates[0].depth)) {
            return undefined;
        }
        return candidates[0].name;
    }
    instancesWithPinConnections(group) {
        let count = 0;
        for (const [, nets] of group.getNets()) {
            let hasConnection = false;
            for (const net of nets) {
                if (net.connections.length > 0) {
                    hasConnection = true;
                    break;
                }
            }
            if (hasConnection) {
                count++;
                if (count > 1) {
                    return count;
                }
            }
        }
        return count;
    }
}
exports.OrCadHierarchicalPortNamingRule = OrCadHierarchicalPortNamingRule;
//# sourceMappingURL=OrcadHierarchicalPortNamingRule.js.map